import AUTH_ACTIONS from '../../constants/actions/auth';
import INSPECTION_DETAIL_ACTIONS from '../../constants/actions/inspection';

class AuthAction {
    static login = (captchaToken, documentType, documentId, password) => ({
        type: AUTH_ACTIONS.LOGIN,
        payload: { captchaToken, documentType, documentId, password }
    });
    static loginOk = payload => ({
        type: AUTH_ACTIONS.LOGIN_OK,
        payload
    });
    static loginError = payload => ({
        type: AUTH_ACTIONS.LOGIN_ERROR,
        payload
    });
    static loginReset = () => ({
        type: AUTH_ACTIONS.LOGIN_RESET
    });

    static logout = () => ({
        type: AUTH_ACTIONS.LOGOUT
    });
    static logoutOk = payload => ({
        type: AUTH_ACTIONS.LOGOUT_OK,
        payload
    });
    static logoutError = payload => ({
        type: AUTH_ACTIONS.LOGOUT_ERROR,
        payload
    });
    static loadToken = payload => ({
        type: AUTH_ACTIONS.TOKEN_LOADED,
        payload
    })
    static me = () => ({
        type: AUTH_ACTIONS.ME
    });
    static meOk = payload => ({
        type: AUTH_ACTIONS.ME_OK,
        payload
    });
    static meError = payload => ({
        type: AUTH_ACTIONS.ME_ERROR,
        payload
    });
    static meReset = payload => ({
        type: AUTH_ACTIONS.ME_RESET,
        payload
    });
    static logoutReset = payload => ({
        type: AUTH_ACTIONS.RESET_LOGOUT_OK,
        payload
    });
    // get report
    static getReportInspection = (payload) => ({
        type: AUTH_ACTIONS.LOAD_INSPECTION_REPORT,
        payload
	})
    static getReportInspectionOk = (payload) => ({
        type: AUTH_ACTIONS.LOAD_INSPECTION_REPORT_OK,
		payload
    })
    static getReportInspectionError = (payload) => ({
        type: AUTH_ACTIONS.LOAD_INSPECTION_REPORT_ERROR,
		payload
	})
	static getReportInspectionReset = () => ({
        type: AUTH_ACTIONS.LOAD_INSPECTION_REPORT_RESET,
	})
}

export default AuthAction;



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js